import CartQuery from 'Query/Cart.query';
import ConfigQuery from 'Query/Config.query';
import RegionQuery from 'Query/Region.query';
import ReviewQuery from 'Query/Review.query';
import { ConfigDispatcher as SourceConfigDispatcher } from 'SourceStore/Config/Config.dispatcher';

/** @namespace Pwa/Store/Config/Dispatcher */
export class ConfigDispatcher extends SourceConfigDispatcher {
    prepareRequest() {
        return [
            RegionQuery.getCountriesQuery(),
            ReviewQuery.getRatingQuery(),
            ConfigQuery.getQuery(),
            ConfigQuery.getCheckoutAgreements(),
            ConfigQuery.getCurrencyData(),
            ConfigQuery.getStoreListField(),
            CartQuery.getCartDisplayConfig(),
        ];
    }
}

export default new ConfigDispatcher();
